module.exports = __webpack_public_path__ + "img/Frame17.fa45534d.png";